export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function(){
      $('.slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay:true,
	autoplaySpeed: 6000,
        speed: 4000,
        slidesToShow: 1,
	adaptiveHeight: true,
      });
      $('.testimonial-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay:true,
        speed: 3000,
        slidesToShow: 1,
      });
      $('.client-slider').slick({
        arrows: false,
        infinite: true,
        autoplay:true,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 3,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
